import { useMemo } from "react"

import { TableRow, Typography } from "@mui/material"

import { BoxSquareColor} from "../../../../Theme/ContainerStyle"
import { TooltipChartWrapper } from "../../../../components/Wrapper"
import { formatColumns } from "../../../../lib/Utility"
import { tooltipPositionPlugin } from "./PluginHACCP"

export default function TooltipChart(props) {
  const {tooltip, lineIndex, titleTooltip,sizeMedia} = props
///QUESTA PARTE DEL CODICE SI OCCUPA DI DIVIDERE I DATI NEL TOOLTIP E RIPARTIRLI
  ///IN PIù COLONNE
  const columns = useMemo(() => {
    const body = tooltip.body || [];
    const numColumns = formatColumns(body)
    return body.reduce((acc, lines, index) => {
      const [label, value] = lines[0].split(":");
      acc[index % numColumns].push({
        label,
        value,
        color: tooltip.colors[index].borderColor,
        id: index
      });
      return acc;
    }, new Array(numColumns).fill(0).map(() => []));
  }, [tooltip.body, tooltip.colors]);
  /////////////////////////////////////////////

  const renderItem = (props) => {
    const {label, value, color, id, index} = props
    const styleFontSize = lineIndex === id ? "14px" : "10px"
    const styleBold = lineIndex === id ? "bold" : ""
    const styleSize = lineIndex === id ? 20 : null

    return (
      <TableRow key={index}>
        <td>
          {/* BOX RAPPRESENTANTE IL QUADRATINO DEL COLORE NEI TOOLTIP DEI GRAFICI */}
          <Typography style={{fontSize:styleFontSize, fontWeight:styleBold}}>
            <BoxSquareColor color = {color} size={styleSize}/>
            {label.replace(/temperatura/g, "temp.")}
          </Typography>
        </td>
        <td>
          <Typography style={{fontWeight:"bold",fontSize:styleFontSize, textAlign: "right"}}>
            {value}
          </Typography>
        </td>
      </TableRow>
    )
  }
  
  return (
    <>
      <TooltipChartWrapper
            tooltip={tooltip}
            columns={columns}
            titleTooltip={tooltip.title && tooltip.title[0] + "\n " + titleTooltip}
            plugin={() => tooltipPositionPlugin({sizeMedia})}
            renderItem={({label, value, color, id}, index) => renderItem({ label, value, color, id }, index)}
      />
    </>
  );
}
